<div class="product-details-container" [avanoLoadingIndicator]="loadingIdentifier">
  <ng-container *ngIf="product$ | async as product">
    <avano-button-bar [buttonsData]="items"></avano-button-bar>

    <div class="avano-content-area">
      <scip-product-declaration *ngIf="product" [product]="product"></scip-product-declaration>
    </div>

    <scip-upload-product-dialog
      *ngIf="showDossierUploadDialog"
      [products]="[product]"
      (closeEvent)="closeDossierUploadDialog($event)"
    ></scip-upload-product-dialog>
  </ng-container>
</div>
